<div class="container">
  <div class="card mt-3">
    <div class="card-body">
      <patron-tabview [tabs]="[{ header: tabTitle, template: tab }]">
        <ng-template #tab>
          @if (loadingConfirm) {
            <div>
              <patron-spinner></patron-spinner>
              <span class="ms-2">Confirmando seu email...</span>
            </div>
          }
          @if (!loadingConfirm) {
            <div>
              @if (!user.email_verified_at) {
                <div>
                  <patron-alert>
                    <p class="font-italic mb-0">
                      Para continuar utilizando o sistema e para garantir a sua segurança,
                      precisamos que confirme o seu email, clicando no link que enviamos para
                      <strong>{{ user.email }}</strong>
                    </p>
                  </patron-alert>
                  <div class="text-right">
                    <patron-button
                      variant="outline"
                      iconName="bi-arrow-clockwise"
                      [loading]="loadingSendEmail"
                      (click)="sendConfirmationEmail()">
                      Não recebi o email
                    </patron-button>
                  </div>
                </div>
              }
              @if (user.email_verified_at) {
                <div>
                  <patron-alert>
                    <p class="font-italic mb-0">
                      Seu email já foi verificado em
                      {{ user.email_verified_at | date: 'dd/MM/yyyy HH:mm' }}, você pode continuar
                      utilizando o sistema normalmente. Obrigado!
                    </p>
                  </patron-alert>
                  <div class="text-right">
                    <patron-button variant="outline" iconName="bi-house-door" routerLink="/">
                      Ir para o início
                    </patron-button>
                  </div>
                </div>
              }
            </div>
          }
        </ng-template>
      </patron-tabview>
    </div>
  </div>
</div>
